import { render } from "./VisualiserLogo.svg?vue&type=template&id=571348f6"
const script = {}
script.render = render

export default script